import React from 'react';
import { FaCheck, FaRocket } from 'react-icons/fa';
import './Pricing.css';

const Pricing = () => {
  const pricingPlans = [
    {
      name: 'Starter',
      price: '4,999',
      description: 'Perfect for small projects and getting started',
      features: [
        'Basic static website',
        'Responsive design',
        'SEO optimization',
      ],
      popular: false
    },
    {
      name: 'Professional',
      price: '16,999',
      description: 'Ideal for growing businesses',
      features: [
        'Full stack web application',
        'Mobile responsive',
        'Database integration',
        'Payment gateway',
        'Performance optimization'
      ],
      popular: true
    },
    {
      name: 'Enterprise',
      price: 'Custom',
      description: 'Tailored solutions for large scale projects',
      features: [
        'Custom full stack solution',
        'Native mobile apps (iOS & Android)',
        'E-commerce platform',
        'Advanced features',
        '3 months support',
        'Dedicated project manager',
        'Priority support'
      ],
      popular: false
    }
  ];

  return (
    <section id="pricing" className="pricing">
      <div className="pricing-container">
        <div className="pricing-header" data-aos="fade-up">
          <h2 className="section-title">Affordable Plans Tailored for Every Business</h2>
          <p className="section-subtitle">
            Starting from just ₹4,999
          </p>
        </div>
        <div className="pricing-includes-above" data-aos="fade-up" data-aos-delay="100">
          <h4 className="includes-title">Every plan includes:</h4>
          <div className="includes-list">
            <div className="include-item">
              <FaCheck className="check-icon" />
              <span>Expert consultation</span>
            </div>
            <div className="include-item">
              <FaCheck className="check-icon" />
              <span>Clean & responsive design</span>
            </div>
            <div className="include-item">
              <FaCheck className="check-icon" />
              <span>SEO-friendly structure</span>
            </div>
            <div className="include-item">
              <FaCheck className="check-icon" />
              <span>Fast development timelines</span>
            </div>
            <div className="include-item">
              <FaCheck className="check-icon" />
              <span>Upgrade options anytime</span>
            </div>
          </div>
        </div>
        <div className="pricing-grid">
          {pricingPlans.map((plan, index) => (
            <div
              key={index}
              className={`pricing-card ${plan.popular ? 'popular' : ''}`}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              {plan.popular && (
                <div className="popular-badge">
                  <FaRocket /> Most Popular
                </div>
              )}
              <div className="pricing-header-card">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  {plan.price === 'Custom' ? (
                    <span className="price-custom">Custom</span>
                  ) : (
                    <>
                      <span className="currency">₹</span>
                      <span className="amount">{plan.price}</span>
                    </>
                  )}
                </div>
                <p className="plan-description">{plan.description}</p>
              </div>
              <ul className="plan-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx}>
                    <FaCheck className="check-icon" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <button className="plan-button">
                Get Started
              </button>
            </div>
          ))}
        </div>
        <div className="pricing-cta" data-aos="fade-up">
          <p>Contact us for a custom quote</p>
          <button className="cta-button" onClick={() => {
            const element = document.getElementById('contact');
            if (element) element.scrollIntoView({ behavior: 'smooth' });
          }}>
            Get Quote →
          </button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;

